export class ReminderSetting {
  enableReminder?: boolean;
  beforeOneDay?: boolean;
  reminderEmailMode?: boolean;
  reminderEmailMessage?: string;
}
